/**
 * Vente par caisses de 6 (panachage libre) — Vignerons de la Cave de Pierrefeu
 *
 * Plutôt qu'un bandeau flottant unique (qui peut se retrouver caché derrière
 * le tiroir panier), ce script insère un message directement à côté de :
 * - chaque bouton "Ajouter au panier" (rappel fixe, pédagogique)
 * - chaque bouton "Commander/Payer" trouvé, panier tiroir ou page panier
 *   (message dynamique : combien il manque, ou caisse complète)
 *
 * Limite connue : ne bloque pas les boutons de paiement dynamique (Shop Pay,
 * PayPal...) qui contournent le panier — à désactiver dans Paramètres du
 * thème > Panier > "Afficher les boutons de paiement dynamique" pour une
 * couverture fiable.
 */
(function () {
  var CASE_SIZE = 6;
  // Types de produit à ignorer dans le calcul (renseigner ce champ "Type de
  // produit" exactement ainsi sur les fiches Coffret et Bag-in-Box côté Shopify)
  var EXCLUDED_TYPES = ["coffret", "grand format"];

  function isExcluded(productType) {
    return EXCLUDED_TYPES.indexOf((productType || "").trim().toLowerCase()) > -1;
  }

  function bottleCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return isExcluded(item.product_type) ? sum : sum + item.quantity;
    }, 0);
  }

  function checkoutButtons() {
    return document.querySelectorAll(
      '[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]'
    );
  }

  function addToCartButtons() {
    var all = document.querySelectorAll(
      'form[action*="/cart/add"] [type="submit"], [name="add"]'
    );
    var visible = Array.prototype.filter.call(all, function (el) {
      return el.offsetParent !== null;
    });
    // Seul le premier bouton visible dans le code (la fiche produit principale,
    // toujours avant les recommandations "Vous aimerez aussi") reçoit le rappel.
    return visible.length ? [visible[0]] : [];
  }

  function ensureSibling(el, className) {
    var next = el.nextElementSibling;
    if (next && next.classList && next.classList.contains(className)) return next;
    var note = document.createElement("div");
    note.className = className;
    el.insertAdjacentElement("afterend", note);
    return note;
  }

  function isProductPage() {
    return /^\/products\//.test(window.location.pathname);
  }

  function insertStaticHints() {
    if (!isProductPage()) return;
    addToCartButtons().forEach(function (btn) {
      var note = ensureSibling(btn, "c6-hint");
      note.textContent =
        "Vendu par caisses de " + CASE_SIZE + " bouteilles — panachage libre entre nos cuvées.";
    });
  }

  function setCheckoutState(disabled) {
    checkoutButtons().forEach(function (el) {
      el.classList.toggle("c6-checkout-disabled", disabled);
      if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.disabled = disabled;
    });
  }

  function ensureNotesWrap(btn) {
    var next = btn.nextElementSibling;
    if (next && next.classList && next.classList.contains("c6-notes")) return next;
    var wrap = document.createElement("div");
    wrap.className = "c6-notes";
    wrap.innerHTML =
      '<div class="c6-inline-note"></div>' +
      '<p class="c6-static-note">Frais de préparation de commande inclus. Carton d\'expédition anti-choc offert.</p>';
    btn.insertAdjacentElement("afterend", wrap);
    return wrap;
  }

  function updateInlineNotes(count) {
    var remainder = count % CASE_SIZE;
    checkoutButtons().forEach(function (btn) {
      var wrap = ensureNotesWrap(btn);
      var note = wrap.querySelector(".c6-inline-note");
      if (count === 0) {
        note.classList.remove("is-visible", "is-complete");
        return;
      }
      if (remainder === 0) {
        note.textContent =
          "Caisse de " + count + " bouteilles complète — vous pouvez commander !";
        note.classList.add("is-visible", "is-complete");
      } else {
        var missing = CASE_SIZE - remainder;
        note.textContent =
          "Il manque " + missing + " bouteille" + (missing > 1 ? "s" : "") +
          " pour compléter votre caisse de " + CASE_SIZE + " (panachage libre).";
        note.classList.add("is-visible");
        note.classList.remove("is-complete");
      }
    });
  }

  function checkCart() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = bottleCount(cart);
        updateInlineNotes(count);
        setCheckoutState(count > 0 && count % CASE_SIZE !== 0);
      })
      .catch(function () {});
  }

  function refreshAll() {
    insertStaticHints();
    checkCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshAll);
  } else {
    refreshAll();
  }

  // Le panier tiroir et les mises à jour de quantité recomposent souvent le
  // DOM dynamiquement : on reste à l'affût plutôt que de dépendre d'un seul
  // événement précis (qui varie selon les thèmes).
  setInterval(refreshAll, 1200);
  document.addEventListener("submit", function () {
    setTimeout(refreshAll, 400);
  });
  document.addEventListener("click", function () {
    setTimeout(refreshAll, 500);
  });
})();